module.exports = __webpack_public_path__ + "assets/img/logo-mastercard.f756d682.svg";